import React, {useEffect, useState} from 'react';
import GoBack from "../../../subsidiary/GoBack/GoBack";
import {useDispatch, useSelector} from "react-redux";
import {ReactComponent as MarkSVG} from '../../../../assets/img/mark.svg';
import {ReactComponent as RectangleSVG} from '../../../../assets/img/rectangle.svg';
import styles from "../ContestBanner/ContestBanner.module.scss";
import {useNavigate} from "react-router-dom";
import {getUserData} from "../../../Profile/profileSlice";
import TextField from '@mui/material/TextField'
import {fetchContest, registrateTeam, setContestId} from "../contestSlice";
import Loader from "../../../subsidiary/Loader/Loader";

const ChooseTopic = () => {
    const dispatch = useDispatch();
    const contestId = localStorage.getItem('contestID');
    const contest = useSelector(state => state.contestSlice.contest)
    const loading = useSelector(state => state.contestSlice.contestLoading)
    const registrateTeamLoading = useSelector(state => state.contestSlice.registrateTeamLoading)
    const registrateTeamError = useSelector(state => state.contestSlice.registrateTeamError)
    const contestError = useSelector(state => state.contestSlice.error)
    const token = useSelector(state => state.loginSlice.token);
    const navigate = useNavigate()
    const user = useSelector(state => state.profileSlice.user)

    const [chosen, setChosen] = useState(null);
    const [city, setCity] = useState('');
    const [fullName, setFullName] = useState('')
    const [initializedFromTeam, setInitializedFromTeam] = useState(false);

    useEffect(() => {
        if (token) {
            if (contestId) {
                dispatch(fetchContest({token, contestId}));
            }
            dispatch(getUserData({token}))
        } else {
            console.log("No Token")
        }
    }, [token, contestId, dispatch]);

    // When editing existing application: pre-fill topic, city, fullName from contest.user_team
    useEffect(() => {
        if (contest?.user_team && !initializedFromTeam) {
            const team = contest.user_team;
            const purposeId = team.purpose?.id ?? team.purpose_id;
            if (purposeId) {
                setChosen(purposeId);
                localStorage.setItem('chosenPurposeID', purposeId);
            }
            if (team.city) setCity(team.city);
            if (team.full_name) setFullName(team.full_name);
            setInitializedFromTeam(true);
        }
    }, [contest?.user_team, initializedFromTeam]);

    const handleCityChange = (e) => {
        setCity(e.target.value)
    }
    const handleFullNameChange = (e) => {
        setFullName(e.target.value)
    }

    const handleNextPage = () => {
        if (!chosen || !city || !fullName) {
            window.showAlert({title: 'Ошибка. Заполните все поля', type: 'error'})
            return;
        }

        dispatch(registrateTeam({
            token,
            contestId: localStorage.getItem('contestID'),
            lead: user.id,
            purpose_id: chosen,
            city: city,
            full_name: fullName
        }))
            .then(() => {
                if (registrateTeamError.failed) {
                    window.showAlert({title: 'Ошибка', type: 'error'})
                } else {
                    navigate('/video')
                }
            })
    }
    const handleSelect = (id) => {
        setChosen(id);
        localStorage.setItem('chosenPurposeID', id);
    };

    // Handle missing contestId
    useEffect(() => {
        if (!loading && !contestId) {
            window.showAlert?.({title: 'Ошибка: ID конкурса не найден', type: 'error'});
            navigate(-1);
        }
    }, [contestId, loading, navigate]);

    // Handle fetch error
    useEffect(() => {
        if (!loading && contestError?.failed && !contest) {
            window.showAlert?.({title: 'Ошибка загрузки данных конкурса', type: 'error'});
        }
    }, [loading, contestError, contest]);

    return (
        <section className='main'>
            {(loading || registrateTeamLoading) ? <Loader/>
                : contest ? (
                    <div className='content-wrapper'>
                        <GoBack nav={-1} text={'На главную'}/>
                        <div className="page-title-container">
                            <h1 className="page-title">
                                Выбор тематики
                            </h1>
                        </div>
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}
                             className="purposes-container">
                            <div>
                                {contest?.purposes?.map(purpose => (
                                    <div
                                        key={purpose.id}
                                        className="purpose-item"
                                        onClick={() => handleSelect(purpose.id)}
                                        style={{
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: '35px'
                                        }}
                                    >
                                        {chosen === purpose.id ? <MarkSVG/> : <RectangleSVG/>}
                                        <span style={{marginLeft: '10px'}}>{purpose.name}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="page-title-container">
                            <h1 className="page-title">
                                Введите город
                            </h1>
                        </div>
                        <div className="purposes-container">
                            <TextField style={{width: '100%'}} onChange={handleCityChange} name="city" required={true}
                                       type='text' id='city' label={`Введите город`} placeholder="" variant="outlined"/>


                        </div>

                        <div className="page-title-container">
                            <h1 className="page-title">
                                ФИО
                            </h1>
                        </div>
                        <div className="purposes-container">
                            <TextField style={{width: '100%'}} onChange={handleFullNameChange} name="fullName"
                                       required={true}
                                       type='text' id='fullName' label={`Введите город`} placeholder=""
                                       variant="outlined"/>


                        </div>
                        <div className={styles.btnContainer}>
                            <button
                                className={styles.conditionBtn}
                                onClick={handleNextPage}
                            >
                                Далее
                            </button>
                        </div>
                    </div>) : (
                    <div className='content-wrapper'>
                        <GoBack nav={-1} text={'На главную'}/>
                        <div className="page-title-container">
                            <h1 className="page-title">
                                {contestError?.failed 
                                    ? 'Ошибка загрузки данных конкурса' 
                                    : !contestId 
                                        ? 'ID конкурса не найден'
                                        : 'Данные конкурса недоступны'}
                            </h1>
                        </div>
                        <div style={{padding: '20px', textAlign: 'center'}}>
                            <p>Попробуйте вернуться назад или обновить страницу</p>
                        </div>
                    </div>
                )}
        </section>
    );
};

export default ChooseTopic;
